import { render, staticRenderFns } from "./m-base.vue?vue&type=template&id=ce65f60a"
import script from "./m-base.vue?vue&type=script&lang=js"
export * from "./m-base.vue?vue&type=script&lang=js"
import style0 from "./m-base.vue?vue&type=style&index=0&id=ce65f60a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports